export class Time {
  h: number = 0;
  m: number = 0;
}
